import Checkbox from "components/checkbox/Checkbox";
import Drawer from "components/drawer/Drawer";
import GearIcon from "icons/GearIcon";
import React from "react";
import { useDisplaySettings } from "./DisplaySettingsProvider";
import { useMeet } from "util/useMeet";
import { updateAttributesOnDocument } from "util/pouchActions";
import { useStatus } from "util/useStatus";
import Select from "components/select/Select";

const components: Record<string, string> = {
  b: "Lifter Name",
  a: "Attempt Info",
  t: "Team Name",
  d: "Weight Class & Divisions",
  r: "Record Attempts",
  p: "Position Change",
  time: "Timer",
  l: "Ref Lights",
  c: "Loading Chart",
  o: "Lifting Order",
  n: "Next bar load",
  no: "Next Lifters",
  co: "Live Stream Bar",
};

export const SettingsDrawer = () => {
  const {
    editMode,
    setEditMode,
    setVisibility,
    visibility,
    maxRecordsToShow,
    setMaxRecordsToShow,
    maxDivisionsToShow,
    setMaxDivisionsToShow,
    setIsTableSettingsModalOpen,
  } = useDisplaySettings();

  const meet = useMeet();

  const { isLocal } = useStatus();

  const setAsDefault = () => {
    updateAttributesOnDocument(meet._id, meet._id, {
      displayDefaultURL: window.location.search,
    });
  };

  return (
    <Drawer
      trigger={
        <>
          <GearIcon />
        </>
      }
    >
      <div className="display-settings-modal-content">
        <Checkbox
          label="Edit Mode"
          value={editMode}
          onCheck={(v) => setEditMode(v)}
        />
        {isLocal && (
          <>
            <hr />
            <button onClick={setAsDefault}>Set as default</button>
          </>
        )}
        <hr />
        <h2>Components</h2>
        {Object.keys(components).map((c) => {
          return (
            <>
              <Checkbox
                key={c}
                label={components[c]}
                value={visibility[c]}
                onCheck={(v) =>
                  setVisibility((prev) => {
                    return { ...prev, [c]: v };
                  })
                }
              />
              {c === "r" && (
                <div style={{ marginLeft: 30, marginBottom: 12 }}>
                  <label>
                    Max Records To Show
                    <Select
                      name="maxRecordsToShow"
                      value={maxRecordsToShow}
                      options={[
                        { label: "1", value: 1 },
                        { label: "2", value: 2 },
                        { label: "3", value: 3 },
                        { label: "4", value: 4 },
                        { label: "5", value: 5 },
                      ]}
                      onChange={(value) =>
                        typeof value === "number" && setMaxRecordsToShow(value)
                      }
                    />
                  </label>
                </div>
              )}
              {c === "d" && (
                <div style={{ marginLeft: 30, marginBottom: 12 }}>
                  <label>
                    Max Divisions To Show
                    <Select
                      name="maxDivisionsToShow"
                      value={maxDivisionsToShow}
                      options={[
                        { label: "1", value: 1 },
                        { label: "2", value: 2 },
                        { label: "3", value: 3 },
                        { label: "4", value: 4 },
                        { label: "5", value: 5 },
                      ]}
                      onChange={(value) =>
                        typeof value === "number" &&
                        setMaxDivisionsToShow(value)
                      }
                    />
                  </label>
                </div>
              )}
              {c === "o" && (
                <div style={{ marginLeft: 30, marginBottom: 12 }}>
                  <button onClick={() => setIsTableSettingsModalOpen(true)}>
                    Open table settings
                  </button>
                </div>
              )}
            </>
          );
        })}
      </div>
    </Drawer>
  );
};
